import { useMemo } from "react";
import styles from "./NavPanel.module.css";

const NavPanel = ({
  postion='left',
  onClick
}) => {
  return (
    (postion == 'full')  ?
      <div className={styles.full} onClick={onClick}> </div>
      :
      <div className={ `${ postion == 'left' ? styles.leftNav : styles.rightNav }` } onClick={onClick}> </div>
  );
};

export default NavPanel;
